import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiGatewayHelperService } from './../../app/services/apigateway-helper.service';

@Injectable()
export class GroupHelperService {

    private groupMembersData : object = {};
    private groups :any;

    constructor(private http: HttpClient, private apiGatewayHelperService: ApiGatewayHelperService) { }
    
    //Get Group Id for learner as first group Id
    getLearnerActiveGroupId() {
        if(this.groups && this.groups.length) {
            let activeGroup = this.groups.find((group)=> group.archived === false)
            return activeGroup ? activeGroup.uuid : "";
        }
            
        else return null;
    }

    //Set Groups associated with the class
    setGroups(groups) {
        this.groups = groups;
    }

    getGroups(){
        return this.groups;
    }

    // returns Groups Member Info for group of selected group Id
    getGroupMembers(groupId) {
        if(this.groupMembersData && this.groupMembersData[groupId]) {
            return this.groupMembersData[groupId];
        }
        return this.http.get(this.apiGatewayHelperService.getApiGatewayPrefixUrl() +'groups/'+ this.apiGatewayHelperService.getSpaceId() + '/members/' + groupId).toPromise()
        .then((data: any)=> {
            this.groupMembersData[groupId] = data.entities;
            return data.entities;
        });
    }

    checkGroupMembers(groupId) {
        return this.groupMembersData[groupId] ? true : false;
    }
  
    setGroupMembersForAGroup(groupId, data) {
        this.groupMembersData[groupId] = data;
    }

    /*
    ToDo after Group SelectionPage
    groupDetailsTransform(groupDetails){
        //Sort groups according to group title
        groupDetails.entities.sort(function(g1, g2) {
            var G1 = g1.title.toUpperCase(); // ignore upper and lowercase
            var G2 = g2.title.toUpperCase(); // ignore upper and lowercase
            if (G1 < G2) {
              return -1;
            }
            if (G1 > G2) {
              return 1;
            }
          
            // names must be equal
            return 0;
          });
        return groupDetails;
    }
    */
    /*ToDo after Group SelectionPage
    //Get Groups of class using Class Id
    getGroupsOfAClass(spaceId,classId) {
    }
    */
}